import styled from 'src/lib/styles/css';

//#region [Props]
type ChartItemAdmissionsProps = {
	label: string;
	value: number | string;
};
//#endregion

//#region [Component]
export default function ChartItemAdmissions({ label, value }: ChartItemAdmissionsProps) {
	return <SAdmissions>
		<SDetailHeader>{label}: </SDetailHeader>
		<span>{value.toLocaleString()}</span>
	</SAdmissions>;
}
//#endregion

//#region [Styles]
const SAdmissions = styled.span`
	margin-right: 30px;
`;

const SDetailHeader = styled.span`
	font-weight: bold;
`;
//#endregion